// Контроллер темы. Управляет атрибутом data-theme на <html>.
// Используется ThemeToggle и инициализацией в main.tsx.

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'ds-theme';

function readSaved(): Theme | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null;
  }
}

function readSystem(): Theme {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

export function getTheme(): Theme {
  return readSaved() ?? readSystem();
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
}

export function setTheme(theme: Theme): void {
  try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* noop */ }
  applyTheme(theme);
}

export function toggleTheme(): Theme {
  const next: Theme = (document.documentElement.getAttribute('data-theme') ?? 'light') === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}

// Вызывается один раз в main.tsx до рендера React — чтобы избежать FOUC.
export function initTheme(): void {
  applyTheme(getTheme());
}
